import { render, staticRenderFns } from "./PlayerHealthBars.vue?vue&type=template&id=64a1d16e&scoped=true&"
import script from "./PlayerHealthBars.vue?vue&type=script&lang=js&"
export * from "./PlayerHealthBars.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHealthBars.vue?vue&type=style&index=0&id=64a1d16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1d16e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
